import { Box } from 'grommet'
import styled from 'styled-components'

export const StyledColumn = styled(Box)`
  align-items: center;
  flex-direction: ${({ flexDirection }) => flexDirection};
  flex-wrap: ${({ flexWrap }) => flexWrap};
  margin: 0 auto;
  max-width: ${({ width }) => width}px;
  position: relative;
  width: 100%;

  ${({ theme }) => theme.below.laptop`
    padding: 0 ${theme.spaces[3]}px;
  `}
`
